import { Component, Input, OnInit } from "@angular/core";
import { BaseModalComponent } from "../base-modal/base-modal.component";
import { LinkService } from "@app/services/link.service";

@Component({
  standalone: false,
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
})
export class AlertComponent extends BaseModalComponent implements OnInit {
  @Input({ required: true }) type: "success" | "warn" | "warn-exclamation" | "success-coke" | "none" | "default" | "";
  @Input({ required: true }) title: string;
  @Input({ required: true }) description: string;
  @Input() mainLabel = "";
  @Input() secondaryLabel = "";
  @Input() mainEvent?: Function;
  @Input() secondaryEvent?: Function;
  @Input() orderId = "";
  @Input() seeRegulamentation = false;

  image: string;

  pdfTerms: string;

  constructor(public linkService: LinkService) {
    super();
  }

  ngOnInit(): void {
    switch (this.type) {
      case "success":
        this.image = "assets/svgs/ok.svg";
        break;
      case "warn":
        this.image = "assets/svgs/notok.svg";
        break;
      case "warn-exclamation":
        this.image = "assets/svgs/warning.svg";
        break;
      case "success-coke":
        this.image = "assets/svgs/coke-happy.svg";
        break;
      case "none":
        this.image = "";
        break;
      case "":
        this.image = "";
        break;
      default:
        this.image = "";
        break;
    }
  }

  async openRegulamentation() {
    this.shared.get<{ pdfTerms: string }>("engine/point/regulation").subscribe((res) => {
      if (res && res.data) {
        this.pdfTerms = res.data.pdfTerms;
        this.ref.detectChanges();
        this.linkService.openPDF(this.pdfTerms);
      }
    });
    // const modal = await this.system.modalCtrl.create({
    //   component: TermsComponent,
    //   backdropDismiss: false,
    //   cssClass: "terms",
    //   componentProps: {
    //     type: "regulation-pp",
    //     title: "Regulamento",
    //   },
    // });
    // modal.present();
  }
}
